import {Component, OnInit, OnChanges, Input, SimpleChanges, Output, EventEmitter} from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {DataHandlerService} from '../../../services/data-handler.service';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-loan-terms',
    templateUrl: './loan-terms.component.html',
    styles: [],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule, MatSelectModule, MatSelectModule, NgFor, MatOptionModule, MatOptionModule, ValidationPartialComponent]
})
export class LoanTermsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public selectedLoanProductType: any;
  @Output() public loanTermChange = new EventEmitter<any>();

  public repaymentTypesSlug = 'frequencies-vx';
  public repaymentTypes = [];
  public loanTerms = [];
  public enableLoanTerms = false;

  private _selectedLoanTerm: any;

  constructor(public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.populateRepaymentTypes();
  }

  ngOnChanges(changes: SimpleChanges) {
    // capture values after refresh
    if (changes['formGroup'] && changes['formGroup']['firstChange']) {
      if (changes['formGroup']['currentValue']['value']['loanTermId']) {
        this._selectedLoanTerm = changes['formGroup']['currentValue']['value']['loanTermId'];
      }
    }

    // capture product selected
    if (changes['selectedLoanProductType']) {
      this.populateLoanTerms(changes['selectedLoanProductType']['currentValue']);
      if (this._selectedLoanTerm) {
        this.updateTerm(this._selectedLoanTerm);
      }
    }
  }

  public updateTerm(slug) {
    this.loanTerms.forEach((term) => {
      if (term.slug === slug) {
        this.loanTermChange.emit(term);
        this.formGroup.get('loanTerm').setValue(term);
      }
    });
  }

  public populateRepaymentTypes() {
    this.repaymentTypes.push({
      id: 'monthly',
      text: 'Monthly',
    });
    this.formGroup.get('repaymentFrequency').patchValue('monthly', {emitEvent: false});
  }

  public populateLoanTerms(product) {
    this.loanTerms = [];
    if (product && product.pricing) {
      // create terms
      product.pricing[0].rates.forEach((rate) => {
        const term = {
          slug: rate.term.value + '-' + rate.term.unit,
          name: rate.term.value + ' ' + rate.term.unit,
          rate: rate
        };
        this.loanTerms.push(term);
      });
      this.enableLoanTerms = true;
    }
  }
}
